<modal-layout-right>
    <ng-container ngProjectAs="[modalTitle]">
        <p class="h3 p-r-3">{{'Request POS product' | translate}}</p>
    </ng-container>
    <ng-container ngProjectAs="[modalBody]">
        <div class="p-a">
            <p class="p2">{{'Please fill in the form below to request a POS product.' | translate}}</p>
            <div class="m-t">
                @if(isConfigLoaded) {
                @if(posFormId) {
                <product-pos-modal-form [identifier]="posFormId"
                                        [sku]="modalData.sku"
                                        [buttonClick]="buttonClick"
                                        (statusChange)="handleStatus($event)"></product-pos-modal-form>
                } @else {
                <p class="p2 col-2">{{'No POS form id found' | translate}}</p>
                }
                } @else {
                <skeleton-loader [variant]="'default'"></skeleton-loader>
                }
            </div>
        </div>
    </ng-container>
    <ng-container ngProjectAs="[modalFooter]">
        <div class="flex flex-middle p-a">
            <button class="button block w-12 m-r-2"
                    [disabled]="!posFormId || status?.busy"
                    (click)="close()">{{'Cancel' | translate}}</button>
            <button class="button block w-12"
                    [disabled]="!posFormId || status?.busy"
                    (click)="submit()">{{'Submit' | translate}}</button>
        </div>
    </ng-container>
</modal-layout-right>
